import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/storage'

const config = {
  apiKey: 'AIzaSyDD9tl57kzOSfViyA5mP9egV6anWCjqnYc',
  authDomain: 'stock-management-system-116eb.firebaseapp.com',
  databaseURL: 'https://stock-management-system-116eb.firebaseio.com',
  projectId: 'stock-management-system-116eb',
  storageBucket: 'stock-management-system-116eb.appspot.com',
  messagingSenderId: '501609979463',
  appId: '1:501609979463:web:4690dc1ee7515310d71b62',
  measurementId: 'G-0EZPP4JQHW'
}

const app = firebase.initializeApp(config)

// Firebase utils
export const db = firebase.firestore()
export const auth = firebase.auth()
export const functions = app.functions('europe-west2')
export const storage = firebase.storage()
export const FieldPath = firebase.firestore.FieldPath
export const TaskEvent = firebase.storage.TaskEvent
export const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp()

export const getPublicImageURL = (subdomain, imageName) => `https://firebasestorage.googleapis.com/v0/b/${config.storageBucket}/o/public%2F${subdomain}%2F${imageName}?alt=media`

